import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { show, hide } from "redux-modal";
import PropTypes from "prop-types";
import * as InventaryService from "../../../../services/InventaryService";
import { useTranslation } from "react-i18next";
import ExpeditionProcessForm from "./expeditionProcessForm.view";
import showDialog from "../../../utils/ShowDialog/ShowDialog";
import moment from "moment-timezone";
import * as ExpeditionProcessService from "../../../../services/expeditionProcessService";
// import { ShowAlertDialog } from "@de-prado-dev/react-component-library";

const ExpeditionProcessFormContainer = ({ data, onSuccess, isDcoop, uuid }) => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  let edit = false;
  uuid ? (edit = true) : (edit = false);
  const [initValues, setInitValues] = useState({});

  const setInitialValues = useCallback(async (data) => {
    let dataFinal;
    dataFinal = {
      article: data.article,
      dateInit: data.dateInit,
      batchOut: data.batchOut,
      type: data.type,
      priority: data.priority,
      status: data.status,
    };
    setInitValues(dataFinal);
  }, []);

  const loadData = useCallback(async () => {
    if (data) {
      setInitialValues(data);
    }
  }, [data, setInitialValues]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        // let result = await InventaryService.newInventary(values);
        let result;
        if (uuid) {
          result = await ExpeditionProcessService.updateProcess(values, uuid);
        } else {
          result = await ExpeditionProcessService.newExpeditionProcess(values);
        }
        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          if (uuid) {
            title = t("forms.expeditionProcess.messages.update.title");
            text = t("forms.expeditionProcess.messages.update.success");
            icon = "success";
          } else {
            title = t("forms.expeditionProcess.messages.create.title");
            text = t("forms.expeditionProcess.messages.create.success");
            icon = "success";
          }
        } else if (!uuid) {
          console.log("ERROR");
          title = "Error";
          text = t("forms.expeditionProcess.messages.create.error");
          icon = "error";
        } else {
          console.log("ERROR");
          title = "Error";
          text = t("forms.expeditionProcess.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          onSuccess();
        };
        showDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      console.log("Error", error);
      showDialog(
        "Error",
        error.data.error.code === "ARTICLE.NOT_FOUND"
          ? t("forms.expeditionProcess.messages.create.articleNotFound")
          : t("forms.expeditionProcess.messages.create.error"),
        "error",
        false,
        "OK",
        false,
      );
    }
  };

  const handleOnback = (popupName) => {
    dispatch(hide(popupName));
  };

  return (
    <>
      <ExpeditionProcessForm
        edit={edit}
        initialValues={initValues}
        onSubmit={handleSubmit}
        onback={handleOnback}
      />
    </>
  );
};

ExpeditionProcessFormContainer.propTypes = {
  t: PropTypes.any,
};

export default ExpeditionProcessFormContainer;
